<script>
import { Select } from 'element-ui';

export default {
  extends: Select,
  data() {
    return {};
  },
  computed: {
    emptyText() {
      if (this.loading) {
        return this.loadingText || this.t('el.select.loading');
      }
      if (this.inputHovering && this.query === '' && this.options.length === 0) return this.noDataText || this.t('el.select.noData');
      if (this.remote && this.query === '' && this.options.length === 0) return false;
      if (this.filterable && this.query && this.options.length > 0 && this.filteredOptionsCount === 0) {
        return this.noMatchText || this.t('el.select.noMatch');
      }
      if (this.options.length === 0) {
        return this.noDataText || this.t('el.select.noData');
      }
      return null;
    }
  }
};
</script>
